export default "__VITE_ASSET__C3WLN3Uk__"